<template>
  <v-date-picker mode="date"
                 v-model="currentValue"
                 :popover="popover"
                 :masks="masques" >
    <template v-slot="{ inputValue, inputEvents }">
          <input v-on="inputEvents"
                 :id="iid"
                 :name="name"
                 :value="inputValue"
                 class="form-control"
                 autocomplete="off"
                 v-tooltip="{content: tooltipContent, placement: tooltipPlacement }"
                 placeholder="jj.mm.aaaa">
    </template>
  </v-date-picker>

</template>

<script>
import { DATE_FORMATS, formatDateToLocalDateFormat, formatJacksonDateForInputTypeDate } from '../../utils/DateUtils';

export default {
  name: 'DatePicker',
  props: {
    value: {
      default: '',
    },
    name: {
      type: String,
      default: '',
    },
    iid: {
      type: String,
      default: undefined,
    },
    tooltipContent: {
      type: String,
      default: '',
    },
    tooltipPlacement: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    popover: { visibility: 'focus' },
    currentValue: '',
    masques: { input: [DATE_FORMATS.DDMMYYYY], data: [DATE_FORMATS.DDMMYYYY] },
  }),
  watch: {
    currentValue(val) {
      // allows us to use v-model on our input.
      this.$emit('input', formatDateToLocalDateFormat(val));
    },
    value: {
      handler(val) {
        this.currentValue = formatJacksonDateForInputTypeDate(val);
      },
    },
  },
  created() {
    if (this.value) {
      this.currentValue = formatJacksonDateForInputTypeDate(this.value);
    }
  },
};
</script>
